module.exports = __webpack_public_path__ + "assets/img/Coupons.cdc887b4.svg";